module.exports = __webpack_public_path__ + "static/media/Pullman Avenue, Half Moon Bay, CA3.552d86ce.jpg";